module.exports = __webpack_public_path__ + "static/media/text-image.5ac0fd12.webp";